import { useState } from "react";

function App() {
  return (
    <div className="counter">
      <Counter />
    </div>
  );
}

function Counter() {
  const [count, setCount] = useState(0);
  const [step, setStep] = useState(1);

  function handleReset() {
    setCount(0);
    setStep(1);
  }

  const date = new Date("June 21 2027");
  date.setDate(date.getDate() + count);

  return (
    <div>
      <div className="step-slider">
        <span>Step: {step}</span>
        <input
          className="slider"
          id="myRange"
          type="range"
          min="0"
          max="10"
          value={step}
          onChange={(e) => setStep(Number(e.target.value))}
        />
      </div>

      <div>
        <button className="btn" onClick={() => setCount((c) => c - step)}>
          -
        </button>
        <input
          type="text"
          value={count}
          onChange={(e) => setCount(Number(e.target.value))}
        />
        <button className="btn" onClick={() => setCount((c) => c + step)}>
          +
        </button>
      </div>

      <div className="text-date">
        <p>
          <span>
            {count === 0
              ? "Today is "
              : count > 0
              ? `${count} days from today is `
              : `${Math.abs(count)} days ago was `}
          </span>
          <span>{date.toDateString()}</span>
        </p>
      </div>

      {count !== 0 || step !== 1 ? (
        <div>
          <button className="btn-reset" onClick={handleReset}>
            Reset
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default App;
